import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class UploadFileAPI {
    constructor() {
        this.fontBaseUrl = new URL("bussched/fonts/", apiBusSchedBaseURL);
        this.layoutBaseUrl = new URL("bussched/layouts/", apiBusSchedBaseURL);
    }

    uploadFont(font) {
        return API.authenticatedRequest({
            url: this.fontBaseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: font
        });
    }

    uploadLayout(layout) {
        return API.authenticatedRequest({
            url: new URL("import", this.layoutBaseUrl),
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: layout
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/bussched/UploadFileAPI.js